const BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000/api";

const getToken = () => {
  try {
    return JSON.parse(localStorage.getItem("auth_token"));
  } catch {
    return null;
  }
};

const request = async (method, path, body = null, options = {}) => {
  const token = getToken();
  const isFormData = body instanceof FormData;

  // PHP/Laravel only parse multipart bodies on POST. For PUT/PATCH with
  // FormData, spoof the method (POST + _method) so the payload isn't dropped.
  let httpMethod = method;
  if (isFormData && (method === "PUT" || method === "PATCH")) {
    body.append("_method", method);
    httpMethod = "POST";
  }

  const headers = {
    Accept: "application/json",
    ...(!isFormData ? { "Content-Type": "application/json" } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const config = {
    method: httpMethod,
    headers,
    ...(body ? { body: isFormData ? body : JSON.stringify(body) } : {}),
  };

  const res = await fetch(`${BASE_URL}${path}`, config);
  const data = await res.json();

  if (!res.ok) {
    const error = new Error(data.message || "Request failed");
    error.status = res.status;
    error.data = data;
    throw error;
  }

  return data;
};

export const api = {
  get: (path, options) => request("GET", path, null, options),
  post: (path, body, options) => request("POST", path, body, options),
  put: (path, body, options) => request("PUT", path, body, options),
  delete: (path, options) => request("DELETE", path, null, options),
};
